import AuthBase from "../AuthBase";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {Avatar, Grid, Stack} from "@mui/material";
import {useContext, useRef, useState} from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import ConfigContext from "../../context/ConfigContext";
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import {Link} from "react-router";
import DinoDialog from "../../components/Dialog";
import Loading from "../../components/Loading";
import {AuthContext} from "../../context/AuthContext";
import NewColleague from "./components/NewColleague";
import {useSnackbar} from "notistack";
import {hasPermission} from "../../utils/permissionUtils";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import SubscriptionContext from "../../context/SubscriptionContext";
import useColleagueQueries from "../../hooks/queries/useColleagueQueries";
import useRegisterQueries from "../../hooks/queries/useRegisterQueries";


const Colleagues = () => {
    const [newColleagueOpen, setNewColleagueOpen] = useState(false)
    const {baseUrl} = useContext(ConfigContext)
    const {hasPlan} = useContext(SubscriptionContext);
    const {getUser} = useContext(AuthContext)
    const newColleagueFormRef = useRef(null)
    const {enqueueSnackbar} = useSnackbar()
    const user = getUser()

    const {getForBusinessQuery} = useColleagueQueries()
    const {registerExistingMutation} = useRegisterQueries()
    const {data: colleagues, isPending: colleaguesLoading} = getForBusinessQuery

    const newColleague = data => registerExistingMutation.mutate(data, {onSuccess: () => {
            setNewColleagueOpen(false)
            enqueueSnackbar('Email kiküldve!', {variant: 'success'})
        }})

    const buttons = [{
        name: 'Új kolléga hozzáadása',
        props: {
            variant: 'contained',
            endIcon: <AddCircleRoundedIcon/>,
            disabled: !hasPlan("colleague", "create") || !hasPermission(user, "colleague", "create"),
            onClick: () => setNewColleagueOpen(true),

        }
    }]

    const filterButtons = [
        {
            name: 'Új kolléga hozzáadása',
            props: {
                variant: 'contained',
                endIcon: <AddCircleRoundedIcon/>,
                disabled: !hasPlan("colleague", "create") || !hasPermission(user, "colleague", "create"),
                onClick: () => setNewColleagueOpen(true)
            }
        }
    ]


    if (colleaguesLoading) return <Loading isLoading />

    return <AuthBase label='Kollégák' buttons={buttons} filterButtonsMobile={filterButtons}>
        <div className="main">
            <Typography variant='subtitle2' style={{color: '#536B74'}}
                        gutterBottom>{colleagues.length} kolléga</Typography>
            <Grid container spacing={2}>
                {colleagues.map((c, i) => <Grid key={`colleage_${i}`} item xs={12} md={3}>
                    <div className="white-card">
                        <Stack spacing={2} alignItems='center'>
                            <Avatar src={baseUrl + c.profile_picture} sx={{width: 90, height: 90}}/>
                            <Typography variant='subtitle2' textAlign='center'>{c.name}</Typography>
                            <Typography variant='body1' color='#536B74'>{c.title}</Typography>
                            <Button
                                variant='outlined'
                                disabled={!hasPermission(user, "colleague", "update", c)}
                                component={Link}
                                to={`/colleagues/${c?.id}`}
                                endIcon={<EditRoundedIcon/>}>
                                Szerkesztés
                            </Button>
                        </Stack>
                    </div>
                </Grid>)}
            </Grid>
        </div>

        <DinoDialog open={newColleagueOpen}
                    handleClose={() => setNewColleagueOpen(false)}
                    title='Új kolléga hozzáadása'
                    subtitle='Adja meg a kolléga e-mail címét és küldünk neki egy regisztrációs linket.'
                    actions={<>
                        <Button variant='outlined' onClick={() => setNewColleagueOpen(false)}>Mégsem</Button>
                        <Button variant='contained' onClick={() => {
                            newColleagueFormRef.current.requestSubmit()
                        }} endIcon={<AddCircleOutlineIcon/>}>
                            Kolléga hozzáadása
                        </Button>
                    </>}>
            <NewColleague handleSubmit={newColleague} reference={newColleagueFormRef}/>
        </DinoDialog>

    </AuthBase>
}

export default Colleagues